import React, { Component } from 'react';
import '../css/getMensaje.css';

class getMensaje extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sitios: [],
      plantillas: [],
      mensaje: '',
      sitioSeleccionado: null
    };
  }

  componentDidMount() {
    const { url_proxyurl, url_global } = this.props;

    fetch(url_proxyurl + url_global + 'webservices/getSitios')
      .then(res => res.json())
      .then(data => this.setState({ sitios: data }))
      .catch(console.error);

    fetch(url_proxyurl + url_global + 'webservices/getPlantillas')
      .then(res => res.json())
      .then(data => this.setState({ plantillas: data }))
      .catch(console.error);
  }

  agregarPlantilla = (texto) => {
    this.setState(prev => ({ mensaje: prev.mensaje + ' ' + texto }));
  }

  seleccionarSitio = (id_sitio_impresora) => {
    this.setState({ sitioSeleccionado: id_sitio_impresora });
  }

  enviarMensaje = () => {
    const { mensaje, sitioSeleccionado } = this.state;
    if (!sitioSeleccionado) {
      alert("⚠️ Seleccione un sitio antes de enviar el mensaje.");
      return;
    }
    if (!mensaje) {
      alert("⚠️ Ingrese Mensaje");
      return;
    }
    const nombre_maquina = this.props.nombre_maquina;
    fetch(this.props.url_proxyurl + this.props.url_global + 'webservices/enviarmensaje', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        mensaje,
        sitioSeleccionado,
        nombre_maquina
      })
    })
      .then(res => res.json())
      .then(() => {
        this.props.Abtn_encerar_cuenta()
      })
      .catch(() => alert('❌ Error.')); 
  }

  render() {
    const { sitios, plantillas, mensaje, sitioSeleccionado } = this.state;

    return (
      <div className="getMensaje-container">
        <h2 className="getMensaje-title">📝 Redacción de Mensaje</h2>
        <div className="getMensaje-grids">
          <div className="getMensaje-lista">
            <h4>Sitio</h4>
            <ul>
              {sitios.map((s, idx) => (
                <li
                key={idx}
                className={this.state.sitioSeleccionado === s.id_sitio_impresora ? 'seleccionado' : ''}
                onClick={() => this.setState({ sitioSeleccionado: s.id_sitio_impresora })}
                >
                {s.Sitio}
                </li>
            ))}
            </ul>
          </div>

          <div className="getMensaje-lista">
            <h4>Opciones por Defecto</h4>
            <ul>
              {plantillas.map((p, idx) => (
                <li key={idx} onClick={() => this.agregarPlantilla(p.opciones_por_Defecto)}>
                  {p.opciones_por_Defecto}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <textarea
          className="getMensaje-textarea"
          value={mensaje}
          onChange={(e) => this.setState({ mensaje: e.target.value })}
          placeholder="Escriba su mensaje aquí..."
        />

        <div className="getMensaje-botones">
          <button
            className="getMensaje-boton enviar"
            onClick={() => {
                if (!this.state.sitioSeleccionado) {
                alert("⚠️ Seleccione un sitio antes de enviar el mensaje.");
                return;
                }
                this.enviarMensaje({
                id_sitio_impresora: this.state.sitioSeleccionado,
                mensaje: this.state.mensaje
                });
            }}
            >
            ✅ ENVIAR
            </button>
          <button className="getMensaje-boton cancelar" onClick={() => this.props.Abtn_encerar_cuenta()}>
            ❌ CANCELAR
          </button>
        </div>
      </div>
    );
  }
}

export default getMensaje;
